import { computed, inject, Injectable, signal } from '@angular/core';
import { LocalStorageService } from '../../../../core/services/LocalStorageService';
import { ISupportSession } from '../interfaces/ISupportSession';

@Injectable({
  providedIn: 'root'
})
export class SupportModeStore {

  public static instance: SupportModeStore;

  private static readonly _storageKey = 'support-session';

  private readonly _localStorageService = inject(LocalStorageService);

  public readonly session = signal<ISupportSession>(this._localStorageService.getItem(SupportModeStore._storageKey));
  public readonly isActive = computed(() => !!this.session());

  public constructor() {
    SupportModeStore.instance = this;
  }

  public enable(session: ISupportSession): void {
    this.session.set(session);
    this._localStorageService.setItem(SupportModeStore._storageKey, session);
  }

  public disable(): void {
    this.session.set(null);
    this._localStorageService.removeItem(SupportModeStore._storageKey);
  }
}
